export enum CaseTypeEnum {
  CASE = 'Case',
  PROBLEM_RECORD = 'ProblemRecords'
}
